<template>
  <div v-if="!showAddAttendee" class="attendees-page">
    <!-- Header -->
    <Header
      class="header-lg"
      :HeaderTitle="'Session attendees'"
      :HeaderSubTitle="this.$store.getters.getProgramName"
      :ShowBack="true"
      v-on:back="back"
    ></Header>

    <!-- Content -->
    <div class="content-wrap">
      <div class="attendees-page__controls">
      <!-- Search -->
      <div class="input-group mb-4">
        <input
          @keyup.enter="this.loadAttendees()"
          v-model="searchInput"
          type="text"
          class="form-control"
          placeholder="Search"
          aria-label="Search attendees"
        />
        <button type="button" aria-label="Clear search"
          @click="clearSearch"
          v-if="searchInput"
          class="input-group-text"
        >
          <img
            src="../assets/images/search/icon-clear-search.svg"
            alt=""
            aria-hidden="true"
            class="icon-clear-search"
          />
        </button>
        <button type="button" aria-label="Search attendees"
          @click="this.loadAttendees()"
          class="input-group-text"
        >
          <img src="../assets/images/attendees/icon-search.svg" alt="" aria-hidden="true" />
        </button>
      </div>

      <!-- Filters -->
      <div class="attendees-filters">
        <!-- Filter ALL -->
        <button type="button"
          @click="setFilter(0)"
          :class="{ active: activeFilter == 0 }"
          :aria-pressed="activeFilter == 0"
          class="attendees-filter"
        >
          All <span class="">{{ programStats.Total }}</span>
        </button>

        <!-- Filter Invited -->
        <button type="button"
          @click="setFilter(1)"
          :class="{ active: activeFilter == 1 }"
          :aria-pressed="activeFilter == 1"
          class="attendees-filter"
        >
          <img
            src="../assets/images/attendees/icon-filter-invited.svg"
            alt="Invited"
          />
          Invited
          <span class="">{{ programStats.Invited }}</span>
        </button>

        <!-- Filter Registered -->
        <button type="button"
          @click="setFilter(2)"
          :class="{ active: activeFilter == 2 }"
          :aria-pressed="activeFilter == 2"
          class="attendees-filter"
        >
          <img
            src="../assets/images/attendees/icon-filter-registered.svg"
            alt="Registered"
          />
          Registered
          <span class="">{{ programStats.Registered }}</span>
        </button>

        <!-- Filter Checked-in -->
        <button type="button"
          @click="setFilter(3)"
          :class="{ active: activeFilter == 3 }"
          :aria-pressed="activeFilter == 3"
          class="attendees-filter"
        >
          <img
            src="../assets/images/attendees/icon-filter-checkedin.svg"
            alt="Checked-in"
          />
          Checked-in
          <span class="">{{ programStats.Attended }}</span>
        </button>
      </div>

      </div>

      <!-- Add attendee btn -->
      <button type="button" class="floating-btn" aria-label="Add attendee" @click="showAddAttendee = !showAddAttendee">
        <img src="../assets/images/attendees/icon-add.svg" alt="" aria-hidden="true" />
      </button>
      
      <!-- Attendee list -->
      <div class="attendees-list">
        <div class="attendees-list__heading" aria-hidden="true">
          <span>Attendee</span><span>Status</span><span>Last change</span>
        </div>
        <!-- Attendee -->
        <div
          v-for="attendee in filteredAttendees"
          v-bind:key="attendee.EventProgramParticipantID"
          class="attendee"
        >
          <button
            type="button"
            class="attendee__main"
            @click="openAttendeeStatus(attendee)"
            :aria-label="`Change status for ${attendeeName(attendee)}`"
          >
            <span class="attendee__status-icon">
              <img
                v-if="attendee.StatusCode === 'present'"
                src="../assets/images/attendees/icon-status-checked-in.svg"
                alt="Checked-in"
                class="attendee__status-img"
              />
              <img
                v-if="attendee.StatusCode === 'registered'"
                src="../assets/images/attendees/icon-status-registered.svg"
                alt="Registered"
                class="attendee__status-img"
              />
              <img
                v-if="attendee.StatusCode === 'invited'"
                src="../assets/images/attendees/icon-status-invited.svg"
                alt="Invited"
                class="attendee__status-img"
              />
            </span>

            <span class="attendee__details">
              <span class="attendee__name">{{ attendeeName(attendee) }}</span>

              <span class="attendee__info">
                <span>
                  {{ attendee.JobPosition
                  }}<span v-if="attendee.JobPosition && attendee.Company">, </span>
                  {{ attendee.Company }}
                </span>
                <span>{{ attendee.Country }}</span>
                <span>{{ attendee.Email }}</span>
              </span>

              <span class="attendee__status" :class="`attendee__status--${attendee.StatusCode || 'unknown'}`">
                {{ { present: 'Checked-in', registered: 'Registered', invited: 'Invited' }[attendee.StatusCode] || 'Unknown' }}
              </span>
              <span class="attendee__status-date">
                {{ formatDateTime(attendee.Attended ?? attendee.Registered ?? attendee.Invited) }}
              </span>
            </span>
          </button>

          <button
            type="button"
            class="attendee__edit"
            @click.stop="editAttendee(attendee)"
            :aria-label="`Edit ${attendeeName(attendee)}`"
            title="Edit attendee"
          >
              <img
              src="../assets/images/attendees/icon-edit.svg"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
  <AddAttendee
    v-if="showAddAttendee"
    :EventId="this.eventId"
    :ProgramId="programId"
    :IsProgram="true"
    :Attendee="this.attendee"
    :IsEdit="this.isEdit"
    :ProgramName="this.programName"
    v-on:closeAddAttendee="closeAddAttendee"
  ></AddAttendee>
  <AttendeeStatus
    v-if="showAttendeeStatus"
    :Name="editingAttendeeName"
    :EventId="this.$store.getters.getEvent?.EventID"
    :ProgramId="programId"
    :EventProgramParticipantId="this.eventProgramParticipantId"
    :EventParticipantId="this.eventParticipantId"
    v-on:closeAttendeeStatus="closeAttendeeStatus"
    :IsProgram="true"
  ></AttendeeStatus>
</template>

<script>
import AddAttendee from "../components/AddAttendeeComponent.vue";
import AttendeeStatus from "../components/AttendeeStatusComponent.vue";
import Header from "../components/HeaderComponent.vue";

export default {
  components: { AddAttendee, AttendeeStatus, Header },
  name: "ProgramAttendeesView",
  data: () => ({
    attendees: Array,
    filteredAttendees: Array,
    programStats: Object,
    activeFilter: 0,
    showAddAttendee: false,
    showAttendeeStatus: false,
    editingAttendeeName: String,
    eventProgramParticipantId: String,
    eventParticipantId: String,
    attendee: Object,
    isEdit: false,
    searchInput: "",
  }),
  methods: {
    loadProgramStats() {
      fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/GetProgramStats/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            EventProgramID: this.programId,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            this.programStats = response.data;
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    async loadAttendees() {
      await fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/GetProgramParticipants/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            Search: this.searchInput,
            EventProgramID: this.programId,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (
            response.serviceStatus === "OK" &&
            response.data.Status === "OK"
          ) {
            this.attendees = response.data.EventProgramParticipants;
            this.setFilter(this.$store.getters.getAttendeeFilter);
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    back() {
      this.$router.back();
    },
    setFilter(id) {
      this.activeFilter = [0, 1, 2, 3].includes(id) ? id : 0;
      this.$store.commit("setAttendeeFilter", { filter: this.activeFilter });

      switch (this.activeFilter) {
        case 0:
          this.filteredAttendees = this.attendees;
          break;
        case 1:
          this.filteredAttendees = this.attendees.filter(
            (attendee) => attendee.StatusCode === "invited"
          );
          break;
        case 2:
          this.filteredAttendees = this.attendees.filter(
            (attendee) => attendee.StatusCode === "registered"
          );
          break;
        case 3:
          this.filteredAttendees = this.attendees.filter(
            (attendee) => attendee.StatusCode === "present"
          );
          break;
        default:
          this.filteredAttendees = this.attendees;
      }
    },
    closeAddAttendee() {
      this.attendee = {};
      this.isEdit = false;
      this.showAddAttendee = false;
      this.loadAttendees();
    },
    openAttendeeStatus(attendee) {
      this.editingAttendeeName = this.attendeeName(attendee);
      this.eventProgramParticipantId = attendee.EventProgramParticipantID;
      this.eventParticipantId = attendee.EventParticipantID;
      this.showAttendeeStatus = true;
    },
    attendeeName(attendee) {
      const name = [attendee.Prefix, attendee.FirstName, attendee.LastName]
        .filter((part) => typeof part === "string" && part.trim())
        .map((part) => part.trim())
        .join(" ");
      return name || attendee.Email || `Attendee ${attendee.EventParticipantID}`;
    },
    closeAttendeeStatus() {
      this.showAttendeeStatus = false;
      this.loadAttendees();
      this.loadProgramStats();
    },
    editAttendee(attendee) {
      this.attendee = attendee;
      this.isEdit = true;
      this.showAddAttendee = !this.showAddAttendee;
    },
    formatDateTime(date) {
      if (date == null || Number.isNaN(new Date(date).getTime())) return "";
      const value = new Date(date);
      const day = new Intl.DateTimeFormat("de-DE", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
      }).format(value);
      const time = new Intl.DateTimeFormat("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(value);
      return `${day} · ${time}`;
    },
    clearSearch() {
      this.searchInput = "";
      this.loadAttendees();
    },
  },
  computed: {
    eventId() {
      return this.$store.getters.getProgram.eventId;
    },
    programId() {
      return this.$store.getters.getEventProgramId;
    },
    programName() {
      return this.$store.getters.getProgram.ProgramName;
    },
  },
  created() {
    this.loadAttendees();
    this.loadProgramStats();
  },
};
</script>
